// The editable lists shown on the Master data screen.
export const MASTER_SECTIONS = [
  { type: 'serviceType', title: 'Types of work', single: 'type of work', icon: 'wrench', help: 'Shown on quotations and service jobs, e.g. New wiring, Repair.' },
  { type: 'workCategory', title: 'Work categories', single: 'work category', icon: 'bolt', help: 'Groups on your work rate card, e.g. Wiring points, Earthing.' },
  { type: 'materialCategory', title: 'Material categories', single: 'material category', icon: 'box', help: 'Groups for materials, e.g. wire, mcb, fan.' },
  { type: 'unit', title: 'Units', single: 'unit', icon: 'layers', help: 'How things are counted or charged: nos, point, meter, roll…' },
  { type: 'hsnSac', title: 'HSN / SAC codes', single: 'HSN / SAC code', icon: 'receipt', help: 'Tax codes printed on bills. Picking one fills its GST rate.' },
  { type: 'gstRate', title: 'GST rates', single: 'GST rate', icon: 'rupee', help: 'Rates offered in GST dropdowns.' },
  { type: 'expenseCategory', title: 'Expense categories', single: 'expense category', icon: 'moneyOut', help: 'Used on expenses and the profit & loss report.' },
];

// Records that have their own screens, listed on the same hub.
export const RECORD_LINKS = [
  { to: '/customers', title: 'Customers', icon: 'users' },
  { to: '/vendors', title: 'Suppliers', icon: 'truck' },
  { to: '/materials', title: 'Materials', icon: 'box' },
  { to: '/work-rates', title: 'Work rates', icon: 'bolt' },
  { to: '/templates', title: 'Quote templates', icon: 'quote' },
  { to: '/team', title: 'Team', icon: 'user', owner: true },
  { to: '/settings', title: 'Company settings', icon: 'settings', owner: true },
];

export const sectionOf = (type) => MASTER_SECTIONS.find((s) => s.type === type);
